import {ILiveEvent} from '@services/live-events/live-events.model';
import {IUserProfile} from '@services/user/user.model';

export interface ILiveEventResponse {
    webinar: ILiveEvent;
}

export interface ILiveEventRecordingWatchtimeResponse {
    recordingWatchTime: ILiveEventRecordingWatchtime[];
}

export interface ILiveEventRecordingWatchtime {
    webinarId: number;
    recordingId: number;
    watchTime: number;
}

export interface IQuestionFilterParams {
    offset: number;
    limit: number;
    webinarId: number;
    sortBy: QuestionsSortByEnum;
    sortDir: QuestionsSortDirEnum;
}

export enum QuestionsSortByEnum {
    NEWEST_FIRST = 'createdAt',
    MOST_UPVOTED = 'upvoteCount',
}

export enum QuestionsSortDirEnum {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export interface IQuestionsResponse {
    webinar_questions: IQuestion[];
    count: number;
    offset: number;
    limit: number;
}

export interface IQuestion {
    id: number;
    question: string;
    author: IUserProfile;
    upvote_count: number;
    user_upvoted: boolean;
    created_at: string | Date;
}
